import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";

import { resolveRouteSeo } from "./seoConfig";
import { applySeoMetadata } from "./seoDom";
import { useOptionalFeatureRegistry } from "../feature-status/FeatureRegistryContext";
import { isFeatureSitemapEligible } from "../feature-status/registry";

export default function SeoManager() {
  const location = useLocation();
  const { lang } = useI18n();
  const registry = useOptionalFeatureRegistry();

  useLayoutEffect(() => {
    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) manifest.setAttribute('href', lang === 'en' ? '/app.en.webmanifest' : '/app.webmanifest');
  }, [lang]);

  useLayoutEffect(() => {
    const base = resolveRouteSeo(location.pathname, location.search, lang);
    // Django already emitted authoritative metadata for database-backed public
    // pages. Do not replace it with the generic dynamic placeholder while the
    // equivalent React view is taking over.
    if (base.pendingDynamicData) return;
    // The build and Django documents are already filtered by the authoritative
    // server registry. Preserve that head while the client registry is loading
    // or unreachable instead of replacing it with a generic nofollow state.
    if (!registry?.ready) return;
    const feature = registry?.getFeatureForPath(location.pathname);
    const registryAllowsIndexing = !feature || isFeatureSitemapEligible(feature);
    applySeoMetadata(registryAllowsIndexing ? base : {
      ...base,
      indexable: false,
      shareable: false,
      robots: "noindex, nofollow, noarchive",
    });
  }, [location.pathname, location.search, registry, lang]);

  return null;
}
